import { useGetLiveDisplayQuery } from '../../../../../../../generated/core-api/graphql-react-query';
import useLiveContext from '../../../../../../LiveContext/useLiveContext';

export default function useDisplay() {
  const { displayId } = useLiveContext();
  const display = useGetLiveDisplayQuery({ input: { id: displayId ?? '' } }, { enabled: !!displayId });
  return display;
}
